/* app/js/src/components/recording/recording-assets-manager/asset-group/asset-group.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.items::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.items::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.items::-webkit-scrollbar-corner {
  background: transparent;
}
.items::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.items::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.items::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.items::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.items::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.items::-webkit-scrollbar-thumb {
  border-width: 0;
}
:host {
  margin-top: 27px;
}
.header {
  display: flex;
}
.header .icon {
  width: 18px;
  height: 18px;
}
.header .title {
  margin-left: 9px;
  font-size: 12px;
  line-height: 17px;
}
.header .title .count {
  font-weight: 700;
  margin: 2px 2px 0 0;
}
.line {
  box-sizing: border-box;
  height: 1px;
  line-height: 1px;
  width: 321px;
  background-color: #ffffff;
  margin: 4px 0 13px 0;
}
.items {
  padding: 0;
  margin-top: 3px;
  list-style-type: none;
  display: flex;
  max-height: 400px;
  height: auto;
  overflow-x: hidden;
  overflow-y: auto;
  flex-wrap: wrap;
  justify-content: flex-start;
  -webkit-transform: translateY(-15px);
  transform: translateY(-15px);
}
/*# sourceMappingURL=asset-group.component.css.map */
